/** Eingabeblöcke von `IwmDialogContainerDuplizieren.razor`. */

import { GruppenkennzeichenDropdown } from '@/components/inputs/GruppenkennzeichenDropdown';
import { TextBox } from '@/components/ui';
import type { ContainerCloneDefinitionItem } from '@/types/definitions';
import type { Container } from '@/types/entities';
import { EntityTypes } from '@/types/enums';

/** Die Quellfelder sind `Readonly` und melden im Altclient keine Änderung zurück. */
function noop(): void {
  /* absichtlich leer */
}

/** Kopfblock „Container (Quelle)" mit den drei gesperrten Feldern. */
export function ContainerCloneSource(props: { source: Container }) {
  const { source } = props;

  return (
    <div className="col-lg-12">
      <h6>Container (Quelle)</h6>
      <div className="row">
        <div className="col-lg-4">
          <TextBox value={source.ContainerNo} onChange={noop} readOnly label="ContainerNo" />
        </div>
        <div className="col-lg-4">
          <TextBox value={source.ContTyp} onChange={noop} readOnly label="ContTyp" />
        </div>
        <div className="col-lg-4">
          <TextBox value={source.Plombe} onChange={noop} readOnly label="Plombe" />
        </div>
      </div>
    </div>
  );
}

export interface ContainerCloneItemProps {
  item: ContainerCloneDefinitionItem;
  /** Nullbasierter Index; die Überschrift zeigt `{index + 1}. Duplikat`. */
  index: number;
  onChange: (patch: Partial<ContainerCloneDefinitionItem>) => void;
}

/** Ein Duplikat: `ContainerNo`, `ContTyp` (Gruppenkennzeichen) und `Plombe`. */
export function ContainerCloneItem(props: ContainerCloneItemProps) {
  const { item, onChange } = props;

  return (
    <>
      <h6 style={{ marginTop: '.5rem' }}>{`${String(props.index + 1)}. Duplikat`}</h6>
      <div className="row">
        <div className="col-lg-4">
          <TextBox
            value={item.ContainerNo}
            onChange={(value) => {
              onChange({ ContainerNo: value });
            }}
            label="ContainerNo"
          />
        </div>
        <div className="col-lg-4">
          <GruppenkennzeichenDropdown
            value={item.ContTyp}
            onChange={(value) => {
              onChange({ ContTyp: value });
            }}
            entity={EntityTypes.Container}
            fieldName="ContTyp"
            label="ContTyp"
          />
        </div>
        <div className="col-lg-4">
          <TextBox
            value={item.Plombe}
            onChange={(value) => {
              onChange({ Plombe: value });
            }}
            label="Plombe"
          />
        </div>
      </div>
    </>
  );
}
